export const formatDate = (dateString) => {
  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Asia/Bishkek",
  };

  const date = new Date(dateString);
  return date.toLocaleDateString("ru-RU", options).replace(",", "");
};
